import { render, staticRenderFns } from "./CityEdit.vue?vue&type=template&id=312bb0e4&scoped=true&"
import script from "./CityEdit.vue?vue&type=script&lang=js&"
export * from "./CityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312bb0e4",
  null
  
)

export default component.exports